import React from 'react'

import CanvasJSReact from '../canvasjs-3.7/canvasjs.react';
import * as PropTypes from "prop-types";
import i18n from "i18next";
import {PatientInput} from "../components/PatientRequest";
import util from "../lib/chart_functions";
// import PopupForm from "../pages/form";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJSChart.propTypes = {
    options: PropTypes.shape({
        data: PropTypes.any,
        exportEnabled: PropTypes.bool,
        theme: PropTypes.string,
        title: PropTypes.any,
        animationEnabled: PropTypes.bool
    })
};
export default class PatientContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            response: '[]',
            status_code: "200",
            headers: ["sex_pie", "age_hist"],
            fields: ["sex", "age"],
            functions: [util.make_pie_from_json_dict, util.make_hist_from_json_dict],
            lists: [],
            checkeds: []
        };
    }



    componentDidMount() {
        // GET request using fetch with set headers
        const headers = {'Access-Control-Request-Method': 'GET'}
        fetch(`${process.env.REACT_APP_BACK_END}/patients/?full=true`, {headers})
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => this.setState({response: data}));
    }

    createNewRequest = (input) => {
        const headers = {'Content-Type': 'application/json'}
        const sex_input = encodeURIComponent(input.sex_input);
        const age_min = encodeURIComponent(input.age[0]);
        const age_max = encodeURIComponent(input.age[1]);
        const age_na = encodeURIComponent(input.age_settings_input.includes('age_na'));
        const age_nb = encodeURIComponent(input.age_settings_input.includes('age_nb'));
        let url = "";
        // if (sex_input !== ""){
        url += `sex=${sex_input}&`
        // }
        // if (age_min !== ""){
        url += `age_min=${age_min}&`
        // }
        // if (age_max !== ""){
        url += `age_max=${age_max}&`
        // }
        // if (age_na !== ""){
        url += `age_na=${age_na}&`
        // }
        // if (age_nb !== ""){
        url += `age_nb=${age_nb}&`
        // }
        fetch(`${process.env.REACT_APP_BACK_END}/patients/?${url}`,
            {headers})
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => this.setState({response: data}));

    }


    render() {
        const {response} = this.state
        const {status_code} = this.state
        let {lists} = this.state
        let {checkeds} = this.state
        const {headers} = this.state
        const {fields} = this.state
        const {functions} = this.state

        const htmls = []
        let L = 0
        let msg = ""
        const ERRORS = ["assays_zero", "patients_zero", "organizations_zero", "collections_zero", "merge_zero"]

        if (status_code === 200 && !ERRORS.includes(response)) {
            const parsed_json = JSON.parse(response)

            const patients = parsed_json["patients"]
            const selectors = parsed_json["selectors"]


            if (typeof patients !== 'undefined') {
                for (const i in fields) {
                    let options = null
                    if (fields[i] !== "age") {
                        options = functions[i](patients[fields[i]], i18n.t(headers[i]), `${fields[i]}_`)
                    } else {
                        options = functions[i](patients[fields[i]], i18n.t(headers[i]), "")
                    }
                    htmls.push(
                        <div className="card-body">
                            <CanvasJSChart options={options}
                                /* onRef={ref => this.chart = ref} */
                            />
                        </div>
                    )
                }
            }

            lists = []
            checkeds = []
            lists['age_settings_list'] = ['age_na', 'age_nb']
            checkeds['age_settings_list'] = [true, true]
            lists['sex_list'] = []
            checkeds['sex_list'] = []
            if (typeof selectors !== 'undefined') {
                const list = selectors['sex_list']
                lists['sex_list'] = list
                checkeds['sex_list'] = Array(list.length).fill(true);
            }

            L = parsed_json['patient_n'];

        } else {
            msg = response
        }
        console.log('Log 1')
        console.log(L)
        return (<div className="main-container container">
            <div className="row">
                <div className="col-4">
                    <PatientInput createNewRequest={this.createNewRequest}
                                  sex={lists['sex_list']}
                                  sex_checked={checkeds['sex_list']}
                                  age_settings={lists['age_settings_list']}
                                  age_settings_checked={checkeds['age_settings_list']}
                                  length_objects={L}
                    />
                </div>
                <div className="col-8">
                    {i18n.t(msg)}
                    {htmls}
                </div>
            </div>
        </div>);
    }

}